import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { DataService } from './data.service';
import { AppConfig } from './config';
import { GUID } from './guid';

@Injectable({
  providedIn: 'root'
})
export class DefaultDataService {
  private dataService: DataService;
  fields;
  guid = new GUID();

  constructor(private httpClient: HttpClient, private appConfig: AppConfig, private router: Router) { 
  }

  setDataService(service: DataService){
    this.dataService = service;
  }

  createDefaultRecords(data) {
    var response;
    // console.log(this.ELEMENT_DATA)
    return Observable.create(observer => {
      setTimeout(() => {

        this.getMetaFieldsForSelection(data).then(res => {
          console.log("response1111", res);
    
          var arrDefaultListviews = this.appConfig.defaultListviews;
          for (let defaultListView of arrDefaultListviews){
            
            console.log("namesuffix", defaultListView.namesuffix);
    
            this.createDefaultCustomView(data, defaultListView).then(res => {
              console.log("response2222", res);
            });
      
          }
    
        });
    
        response = {};
        response.success = 1;
        response.message = "Default records created";
    
        observer.next(response)
        observer.complete();
      }, 50)
    })
  }

  /*createDefaultRecords(data): Observable<any> {
    var response;

    this.getMetaFieldsForSelection(data).then(res => {
      console.log("response1111", res);

      var arrDefaultListviews = this.appConfig.defaultListviews;
      for (let defaultListView of arrDefaultListviews){
        
        console.log("namesuffix", defaultListView.namesuffix);

        this.createDefaultCustomView(data, defaultListView).then(res => {
          console.log("response2222", res);
        });
  
      }

    });

    response = {};
    response.success = 1;
    response.message = "Default records created";
    
    return response;

  }*/

  getMetaFieldsForSelection(data) {
    return new Promise((resolve, reject) => {

      console.log("getMetaFieldsForSelection");
      
      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));
      
      let postOption = {
        organizationid: data.organizationid,
        userid: data.userid,
        username: data.username,
        useralias: data.useralias,
        profileid: data.profileid,
        data: {
          metafield: {
            metaobjectid: data.data.metaobject.id,
            metaobjectname: data.data.metaobject.name
          }
        }
      }
    
      console.log("postOption", postOption);

      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;
            resolve(null);
          }
          else {
            console.log("error");
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          resolve(null);
        }

      );

    });
  }

  getDefaultCriteria(data, metalayoutId){
    var arrDefaultCriteria = [];

    //default criteria deleted equals false
    var fieldsFilter =  this.fields.filter(function(field) {
      return field.fieldname.toLowerCase().trim() == 'deleted';
    });

    console.log("fieldsFilter***deleted", fieldsFilter);

    for (let fld of fieldsFilter){

      var metaProfileLayoutCriteria = {
        id: this.guid.getGUID("metaprofilelayoutcriteria"),
        metaobjectid: data.data.metaobject.id,
        metalayoutid: metalayoutId,
        metafieldid: fld.id,
        fieldname: fld.fieldname,
        fieldtype: fld.fieldtype,   
        operator: "equals",
        value: false,
        filterlogic: "AND",
      };

      arrDefaultCriteria.push(metaProfileLayoutCriteria);
      
    }    

    return arrDefaultCriteria;
  }

  createMetaLayoutGroupField(data, metalayoutId, metaLayoutGroupId){
    //get default metagroupfield details and assign it to postoption

    var arrDefaultField = [];

    //create operator type picklist from operatortypes
    for (let i = 0; i < this.appConfig.defaultListviewFields.anyothers.length; i++) {
      //convert to titecase
      var listviewField = this.appConfig.defaultListviewFields.anyothers[i];

      var fieldsFilter =  this.fields.filter(function(field) {
        return field.fieldname.toLowerCase().trim() == listviewField.toLowerCase().trim();
      });

      if(fieldsFilter.length > 0){
        arrDefaultField.push(fieldsFilter[0]);
      }

    }

    var arrMetaGroupField = [];

    for (let j = 0; j < arrDefaultField.length; j++) {
      var field = arrDefaultField[j];
      
      var required = false;
      if(field.fieldname.toLowerCase() == 'id') required = true;

      var metaGroupField = {
        id: this.guid.getGUID("metalayoutgroupfield"),
        metaobjectid: data.data.metaobject.id,
        embeddedobject: false,
        parentobjectid: '',
        metalayoutid: metalayoutId,
        metagroupid: metaLayoutGroupId,
        metafieldid: field.id,
        fieldname: field.fieldname,
        fieldtype: field.fieldtype,
        labelname: field.labelname,
        supportingobjectid: '',
        supportingfield: false,
        standard: field.standard,
        fieldsequence: j+1, //index j
        defaultvalue: field.defaultvalue,
        required: required,
        primary: field.primaryfield,
        visible: field.visible,
        readonly: true,
        derivedfield: false,
        active: true,
        attributes: {},
        createddate: field.createddate,
      };
      
      var metaGroupFieldAttributes = {};
      if(field.fieldname.toLowerCase() =='id'){
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: '',
          linkfield: '',
          hidden: true,
          linkrelativeurl: '',
          islink: false
        };
      }
      else if (field.fieldname.toLowerCase() =='name'){
        //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
        var linkrelativeurl = 'web/v1/lead/leadview';
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: data.data.metaobject.name,
          linkfield: 'id',
          hidden: false,
          linkrelativeurl: linkrelativeurl,
          islink: true
        };
      }
      // else if (metaGroupFieldAttributes===undefined){
      //   metaGroupFieldAttributes = {
      //     recordtypeexist: false,
      //     object: '',
      //     linkfield: '',
      //     hidden: false,
      //     linkrelativeurl: '',
      //     islink: false
      //   };
      // }
      else{        
        metaGroupFieldAttributes = {
          recordtypeexist: "false",
          object: '',
          linkfield: '',
          hidden: false,
          linkrelativeurl: '',
          islink: false
        };
      }

      metaGroupField.attributes = metaGroupFieldAttributes;

      arrMetaGroupField.push(metaGroupField);

    }

    return arrMetaGroupField;
  }

  createDefaultCustomView(data, defaultListView) {
    return new Promise((resolve, reject) => {

      console.log("createRecentlyViewedCustomView");

      var metaobject = data.data.metaobject;
      var mode = data.data.metaobject.mode;
      var metalayoutName = "";

      if(defaultListView.namesuffix.includes("Recently_Viewed")){
        metalayoutName = metaobject.name + '_' + 'CustomView' + '_' + defaultListView.namesuffix;
      }
      else{
       
        // metalayoutName = metaobject.name + '_' + 'CustomView' + '_' + defaultListView.namesuffix + '_' +  metaobject.pluralname;
        metalayoutName = metaobject.name + '_' + 'CustomView' + '_' + defaultListView.namesuffix;

      }

      var viewName = defaultListView.viewnameprefix + '_' +  metaobject.pluralname;
      var displayName =  defaultListView.displaynameprefix + ' ' +  metaobject.pluralname;
      var targetURL = 'api/v1/' + metaobject.name.toLowerCase() + '/all/custom';
      var filterByOwner = defaultListView.filterbyowner;
      var publicAccess = defaultListView.publicaccess;
      var active = defaultListView.active;

      var metalayoutAttributes = {
        relatedlistflag: false,
        notesandattachments: false,
        activity: false
      }
  
      var metalayoutId = this.guid.getGUID("metalayout");
  
      //prepare data for saving: application
      let postOption = {
        organizationid: data.organizationid,
        userid: data.userid,
        username: data.username,
        useralias: data.useralias,
        data: {
          metalayout: {
            metaobjectid: metaobject.id,
            metaobjectname: metaobject.name,
            embeddedobject: false,
            parentobjectid: '',
            relatedobjectid: '',
            mode: mode,

            id: metalayoutId,
            displayname: displayName,
            viewname: viewName,
            name: metalayoutName,
            action: 'CustomView',
            targeturl: targetURL,
            columncount: 0,
            tabkeyorder: "L-R",
            hascustomview: false,
            clonable: false,
            editable: false,
            deletable: false,
            haskanbanview: true,
            searchtext: '',
            sortby: 'createdon',
            sortorder: 'desc',
            pagesize: this.appConfig.appDefaultPageSize,
            pagenumber: 1,
            publicaccess: publicAccess,
            filterbyowner: filterByOwner,
            queueid: '',
            queuename: '',
            active: active,
            attributes: metalayoutAttributes,
            metaprofilelayout: {}, 
            metaprofilelayoutcriterias: [],
            metalayoutgroup: {}, 
            metalayoutgroupfields: [],
            metaprofilelayoutweb: {}, 
            metalayoutbuttons: [], //will be served at server
          }
        }
      }

      //metaprofilelayout
      var metaProfileLayoutAttributes = {
        "queueid": '',
        "filterbyowner": filterByOwner,
      }
  
      var metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");

      var metaProfileLayout = {
        id: metaProfileLayoutId,
        metaobjectid: metaobject.id,
        embeddedobject: false,
        parentobjectid: '',
        metalayoutid: metalayoutId,
        recordtypeid: '',
        profileid: '',
        description: '',
        actiontype: 'CustomView',
        active: true,
        attributes: metaProfileLayoutAttributes,
      };

      //push metaprofilelayout to request data (postoption)
      postOption.data.metalayout.metaprofilelayout = metaProfileLayout;

      //metaprofilelayoutcriteria
      
      //create criteria details & push it to postOption
      var arrMetaProfileLayoutCriteria = this.getDefaultCriteria(data, metalayoutId);
      //push metalayoutgroup to request data (postoption)
      postOption.data.metalayout.metaprofilelayoutcriterias = arrMetaProfileLayoutCriteria;

      //****** metalayoutgroup  *********/
    
      //get metalayoutgroup details and assign it to postoption
      var metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");

      var metaLayoutGroup = {
        id: metaLayoutGroupId,
        metaobjectid: metaobject.id,
        embeddedobject: false,
        parentobjectid: '',
        metalayoutid: metalayoutId,
        name: viewName,
        showondetailpage: true,
        showoneditpage: true,
        active: true,
      };

      //push metalayoutgroup to request data (postoption)
      postOption.data.metalayout.metalayoutgroup = metaLayoutGroup;

      //****** metalayoutgroupfield *********/
      
      //create metalayoutgroupfield and assign it to postOption
      var arrMetaGroupField = this.createMetaLayoutGroupField(data, metalayoutId, metaLayoutGroupId);
      postOption.data.metalayout.metalayoutgroupfields = arrMetaGroupField;

      //****** metaprofilelayout  *********/

      //metaprofilelayoutweb
      var metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");

      var metaProfileLayoutWeb = {
        id: metaProfileLayoutWebId,
        metaobjectid: metaobject.id,
        metaobjectname: metaobject.name,
        embeddedobject: false,
        parentobjectid: '',
        metalayoutid: metalayoutId,
        metalayoutname: metalayoutName,
        recordtypeid: null,
        recordtypename: '',
        profileid: null,
        profilename: '',
        description: '',
        actiontype: 'CustomView',
        active: true,
        layoutjsontext: {},
        fieldjsontext: {},
        criteriajsontext: {},
      };

      //push metaprofilelayout to request data (postoption)
      postOption.data.metalayout.metaprofilelayoutweb = metaProfileLayoutWeb;

      console.log("postOption", postOption);

      this.dataService.upsertMetalayout(postOption).subscribe(
        res => {
          console.log(res);
          if (res !== null && res.success == 1) {
            console.log("success");
            resolve(null);
          }
          else {
            console.log("error");
            resolve(null);
          }
        },
        err => {
          console.log("Error***:", err);
          resolve(null);
        }

      );

    });
  }

  
}
